/**
 * useOrderTrackingLink — fetch shareable capability-token tracking URL for an order
 */
import { useQuery } from "@tanstack/react-query";
import { getOrderTrackingLink } from "../services/orderService.js";

/**
 * @param {string|null|undefined} orderId
 * @param {{ enabled?: boolean }} [options]
 */
export function useOrderTrackingLink(orderId, options = {}) {
  const normalized = String(orderId || "").trim();
  const enabled = Boolean(normalized) && (options.enabled ?? true);

  return useQuery({
    queryKey: ["orderTrackingLink", normalized],
    queryFn: () => getOrderTrackingLink(normalized),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
